import ShareRoundedIcon from '@mui/icons-material/ShareRounded'
import { Box, Tooltip, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import CardAppointment from 'component/Appointment/CardAppointment'
import SectionAppointment from 'component/Appointment/GraphAppointment'
import { imgs, onProfileError } from 'constants/images'
import { AppointmentCardItemDayInterface, AppointmentDisplayDayInterface, AppointmentTags } from 'features/counter/appointment/appointment-interface'
import { getColorStatus } from 'features/counter/doctor-schedule/doctor-schedule'
import _ from 'lodash'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** UTILS */
import { colors } from 'constants/theme'

/** ICONS */
import IconButton from '@mui/material/IconButton'


import { fileUrl } from 'api/api'
import { selectMe } from 'app/slice/user.slice'
import CardBreak from 'component/Appointment/CardBreak'
import ButtonCustom from 'component/Button/ButtonCustom'
import { ScrollSync, ScrollSyncNode } from 'component/syncScroll'
import { useSelector } from 'react-redux'
import UseScroll from 'utils/useScroll'
import { useFormatSizeAppointment } from './appointment'
import { BoxTag } from './style'

const AreaArrow = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  marginTop: 56,
  width: 88,
  zIndex: 5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  '&.arrow-next': {
    right: 0
  },
  '&:hover .MuiIconButton-root': {
    background: `${colors.disabledGray} !important`
  },
  [theme.breakpoints.down('lg')]: {
    display: 'none'
  }
}))

const CustomIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: colors.lightGray,
  border: `1px solid ${colors.lightGray}`,
  color: colors.white,
  padding: 0,
  width: 34,
  height: 34,
  transition: 'opacity .3s ease',
  '& svg': {
    fontSize: 26
  }
}))

const DivProfileDoctor = styled('div')(({ theme }) => ({
  border: `1px solid ${colors.black}`,
  height: '40px',
  width: '40px',
  borderRadius: '50rem',
  margin: '0.25rem',
  overflow: 'hidden',
  '& img': {
    objectFit: 'cover',
    height: '100%',
    width: '100%'
  }
}))

const DivServicePointName = styled('span')(({ theme }) => ({
  marginLeft: 10,
  color: colors.secondSky,
  fontSize: 11,
  '& div': {
    width: 100,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}))

const DivDisplayDay = styled('div')<{ listAppointmentDay: any, width: string }>(({ theme, listAppointmentDay, width }) => ({
  // overflow: 'auto',
  maxHeight: '100%',
  '& .service-slider-container': {
    '&::-webkit-scrollbar': {
      width: 1,
      height: '7px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: colors.disabledGray,
      borderRadius: 50
    }
    // minWidth: `calc(${listAppointmentDay.length * 435}px + 4.05rem)`
  },
  '& .section-head-doctor': {
    paddingTop: '1rem',
    // paddingLeft: '3.05rem',
    // width: `calc(${listAppointmentDay.length * 435}px + 3.05rem)`,
    zIndex: 300,
    '& .profile-doctor': {
      border: `1px solid ${colors.lightGray}`,
      height: '40px',
      width: '40px',
      borderRadius: '50rem',
      margin: '0.25rem',
      overflow: 'hidden',
      '& img': {
        objectFit: 'cover',
        height: '100%',
        width: '100%'
      }
    }
  },
  '& .section-body-appointment': {
    // paddingLeft: '3.05rem',
    // width: `calc(${listAppointmentDay.length * 435}px + 4.05rem)`,
    // overflow: 'auto',
    '.layout-schedule': {
      overflow: 'hidden'
    },
    '& .graph-appointment': {
      width: `${width}`,
      display: 'inline-block',
      margin: '0 0.05rem 0 0.05rem'
    }
  },
  '& .div-time': {
    width: 48,
    display: 'inline-block',
    position: 'sticky',
    marginTop: 88,
    // overflow: 'auto',
    maxHeight: '100%'
  }
}))

const CardDoctor = styled('div')<{ width: string }>(({ theme, width }) => ({
  display: 'inline-block',
  width: `${width}`,
  minHeight: '100px',
  height: '100%',
  border: `1px solid ${colors.lightGray}`,
  margin: '0 0.05rem 0 0.05rem',
  background: colors.filterDropdown,
  position: 'relative',
}))


export interface DisplayDayProps {
  branchId: number
  branch: string
  listAppointmentDay: AppointmentDisplayDayInterface[]
  timeRange: any[]
  onEdit?: (id: number) => void
  onEditSpecialInfo?: (id: number) => void
  onEditFeedback?: (id: number) => void
  clinicIsClose: boolean
  type?: string
  formAppointmentWidth?: number
  onClickShare?: (doctor: any) => void
}

type FixPositionType = {
  top: number;
  left: number;
};

export default function DisplayDay(props: DisplayDayProps) {
  const { t, i18n } = useTranslation()
  const [viewDetails, setViewDetails]: any = useState({})
  const [branch, setBranch] = useState<any>()
  const user = useSelector(selectMe)
  const sizeSectionAppointment = useFormatSizeAppointment();
  const [widthCardAppointment, setWidthCardAppointment] = useState<number>(sizeSectionAppointment)

  const { hideArrow, scrollBehavior, onPressArrow } = UseScroll('.service-slider-container', '.service-slider-wrap', widthCardAppointment)

  const displayRef = useRef<any>(null)
  const containerRef = useRef<any>(null)
  const cardDetailRef = useRef<HTMLDivElement | null>(null)

  const [position, setPosition] = useState<FixPositionType | null>(null);
  const initialPositionRef = useRef<FixPositionType | null>(null);
  const isCardInteractingRef = useRef<boolean>(false);
  const [timeOutClinic, setTimeOutClinic] = useState<any>('');
  const idSuffix = props.type === 'share' ? '-share' : '';


  useEffect(() => {
    setBranch(props.branch)
  }, [props.branch])

  // Smooth scroll sync with interaction detection - Direct DOM manipulation (both X and Y)
  useEffect(() => {
    let ticking = false;

    const handleScroll = (e: any) => {
      // หยุดชั่วคราวถ้ากำลัง interact กับ card
      if (isCardInteractingRef.current || !viewDetails?.isShow) return;

      const scrollTop = e.target?.scrollTop || 0;
      const scrollLeft = e.target?.scrollLeft || 0;

      if (!ticking) {
        requestAnimationFrame(() => {
          if (initialPositionRef.current) {
            const cardElement = document.querySelector('.card-appointment-detail-popup') as HTMLElement;
            if (cardElement) {
              // คำนวณตำแหน่งใหม่ทั้ง X และ Y
              const newTop = initialPositionRef.current.top - scrollTop;
              const newLeft = initialPositionRef.current.left - scrollLeft;

              // ใช้ CSS properties โดยตรง (ไม่ผ่าน React state)
              cardElement.style.transform = `translate3d(${newLeft}px, ${newTop}px, 0)`;
              cardElement.style.willChange = 'transform';
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    const service = document.getElementById(`service-slider-container${idSuffix}`);
    if (service) {
      service.addEventListener('scroll', handleScroll, { passive: true });

      // เพิ่ม overscroll-behavior เพื่อป้องกันการกระตุก
      service.style.overscrollBehavior = 'contain';
    }

    // หยุด scroll sync เมื่อเริ่ม interact
    const handleInteractionStart = (e: Event) => {
      const target = e.target as HTMLElement;
      // เช็คว่าคลิกที่ card detail หรือ children ของมัน
      if (target.closest('.card-appointment-detail-popup')) {
        isCardInteractingRef.current = true;
      }
    };

    // เปิด scroll sync อีกครั้งหลังจาก interact เสร็จ
    const handleInteractionEnd = () => {
      setTimeout(() => {
        isCardInteractingRef.current = false;
      }, 150);
    };

    // ฟัง event แบบ global
    document.addEventListener('mousedown', handleInteractionStart, true);
    document.addEventListener('mouseup', handleInteractionEnd);
    document.addEventListener('touchstart', handleInteractionStart, true);
    document.addEventListener('touchend', handleInteractionEnd);

    return () => {
      if (service) {
        service.removeEventListener('scroll', handleScroll);
      }
      document.removeEventListener('mousedown', handleInteractionStart, true);
      document.removeEventListener('mouseup', handleInteractionEnd);
      document.removeEventListener('touchstart', handleInteractionStart, true);
      document.removeEventListener('touchend', handleInteractionEnd);
    };
  }, [viewDetails, idSuffix])


  const groupAppointmentByHour = (apt: any) => {
    const newApt: any = _.chain(apt)
      .map((i: any) => { return i })
      .groupBy('start')
      .map((value: any) => ({ data: value }))
      .value()

    return newApt
  }


  const scrollTabDoctor = (e: any) => {
    // e.preventDefault();
    const tabDoctor: any = document.getElementById("service-slider-container");
    document.getElementById("layout-schedule")?.scrollTo(0, tabDoctor?.scrollTop)
    document.getElementById("service-slider-container")?.scrollTo(tabDoctor?.scrollLeft, tabDoctor?.scrollTop)
    // if (viewDetails?.isShow) setViewDetails(() => ({ isShow: false }))
  }

  const renderImgDoctor = (lad: AppointmentDisplayDayInterface) => {
    if (lad?.doctorProfile && !lad?.doctorProfile?.includes("simple-user-profile.png")) {
      return `${fileUrl}/${lad.doctorProfile}`
    } else {
      return imgs.defaultAvatar
    }
  }

  console.log(branch?.showAppointmentSharing, 'branch')

  return (
    !props.clinicIsClose && (
      <DivDisplayDay
        ref={displayRef}
        listAppointmentDay={props.listAppointmentDay}
        className="display-days position-relative d-flex flex-column"
        width={`${widthCardAppointment}px`}
      >
        {/* <AreaArrow className={`arrow-prev ${hideArrow === 'prev' || hideArrow === 'both' ? 'd-none' : ''} opacity-0`}
          style={{ cursor: 'default' }}>
          <CustomIconButton>
            <ArrowBack />
          </CustomIconButton>
        </AreaArrow>
        <AreaArrow className={`arrow-next ${hideArrow === 'next' || hideArrow === 'both' ? 'd-none' : ''} opacity-0`}
          style={{ cursor: 'default' }}>
          <CustomIconButton>
            <ArrowForward />
          </CustomIconButton>
        </AreaArrow> */}
        <ScrollSync proportional={false}>
          <Box className='overflow-auto' style={{ display: 'flex', position: 'relative', height: '100%' }}
            sx={{
              "#layout-schedule::-webkit-scrollbar": {
                width: '0px',
                height: '0px',
              },
              '.div-time': {
                paddingTop: '28px',
                marginBottom: '28px'
              },
              '.layout-schedule': {
                overflowY: 'hidden !important'
              }
            }}>
            <ScrollSyncNode group="day" onScroll={scrollTabDoctor}>
              <div id={`div-time${idSuffix}`} className={'div-time none-scroll'}>
                {props.listAppointmentDay.length > 0 && (
                  <SectionAppointment branchId={1} timeRange={props.timeRange} isShowTime={true} enableTimeTooltip showMinute />
                )}
              </div>
            </ScrollSyncNode>
            <ScrollSyncNode group={`day${idSuffix}`} onScroll={scrollTabDoctor}>
              <div id={`service-slider-container${idSuffix}`} className="service-slider-container overflow-scroll" style={{ position: 'relative', zIndex: 1 }}>
                <div id={`service-slider-wrap${idSuffix}`} className="service-slider-wrap">
                  <Box
                    ref={containerRef}
                    className="section-head-doctor sticky-top bg-white d-flex flex-row"
                    style={{ width: 'fit-content' }}
                    sx={{
                      '.doctor-bg:nth-child(even)': {
                        background: colors.appointmentDoctor.colorEven,
                      },
                      '.doctor-bg:nth-child(odd)': {
                        background: colors.appointmentDoctor.colorOdd,
                      }
                    }}
                  >
                    {_.map(props.listAppointmentDay, (lad: AppointmentDisplayDayInterface, i: number) => (
                      <CardDoctor key={i} className='doctor-bg' width={`${widthCardAppointment}px`}>
                        {props.type !== 'share' && branch?.showAppointmentSharing === '1' && (<Box
                          sx={{ position: 'absolute', top: 4, right: 4, zIndex: 1 }}>
                          <ButtonCustom
                            style={{ backgroundColor: colors.white }}
                            textButton={t('DOCTOR_SCHEDULE.BUTTON.SHARE')}
                            type="button"
                            variant="outlined"
                            startIcon={<ShareRoundedIcon />}
                            onClick={() => props.onClickShare && props.onClickShare(lad)}
                          />
                        </Box>
                        )}
                        <Box color='white' paddingLeft="8px" paddingRight="16px" paddingTop="4px" height="20px" display="flex" alignItems="center" borderRadius="0px 0px 8px 0px" sx={{ width: 'fit-content', maxWidth: '100%', backgroundColor: '#1CB99A' }}>
                          <Tooltip title={lad[`servicePointName${i18n.language !== "th" ? "En" : ""}`]} placement={'top-start'} >
                            <Typography paddingBottom="2px" fontSize="11px">{lad.servicePointName ? lad[`servicePointName${i18n.language !== "th" ? "En" : ""}`] : 'ไม่ระบุห้องตรวจ'}</Typography>
                          </Tooltip>
                        </Box>
                        <Row className="mx-0" style={{ paddingTop: '4px', width: `${widthCardAppointment}px` }}>
                          <Col sm={'auto'} className={'text-nowrap overflow-hidden w-auto'}>
                            <DivProfileDoctor className="profile-doctor">
                              <img src={renderImgDoctor(lad)} onError={onProfileError} alt={lad?.doctorFullname} />
                            </DivProfileDoctor>
                          </Col>
                          <Col className={'px-0 text-nowrap overflow-hidden'}>
                            <p className="mb-0 d-flex align-items-center">
                              <Tooltip title={<div>{lad.doctorFullname}</div>} placement={'top-start'}>
                                <strong>{lad.doctorFullname}</strong>
                              </Tooltip>
                            </p>
                            {lad?.tags?.length ?
                              <BoxTag>
                                {lad?.tags.map((item: AppointmentTags, index: number) => {
                                  return (
                                    <Box
                                      key={index}
                                      title={item.tagName}
                                      className={`items-tag`}
                                      sx={{ backgroundColor: item.color, }}
                                    />
                                  )
                                })}
                              </BoxTag>
                              : <></>
                            }
                            <span className="fz-14">
                              <span className='pr-1'>{t('HOME.TITLE.START_WORK')}</span>
                              {lad?.statusDoctorSchedule === "NORMAL" && (
                                `${lad.doctorSchedule} ${i18n.language === "th" ? 'น.' : ''} (${lad.countAppointment})`
                              ) || (
                                  <span style={{ color: getColorStatus(lad?.statusDoctorSchedule || '', 'COLOR') }}>{lad?.statusDoctorSchedule ? `(${t(`DOCTOR_SCHEDULE.STATUS.${lad?.statusDoctorSchedule}`)})` : '-'}</span>
                                )}
                            </span>
                          </Col>
                        </Row>
                      </CardDoctor>
                    ))}
                  </Box>
                  <div id={`section-body-appointment${idSuffix}`} className="section-body-appointment d-flex flex-row">
                    {_.map(props.listAppointmentDay, (lad: AppointmentDisplayDayInterface, i: number) => {
                      const countAp = 0
                      const checkTimeStart = '';
                      return (
                        <div key={i} className={'graph-appointment'} style={{ width: `${widthCardAppointment}px` }}>
                          <SectionAppointment
                            enableTimeTooltip
                            branchId={1}
                            width={widthCardAppointment}
                            isShowTime={false}
                            showMinute
                            timeRange={props.timeRange}
                            hideDot={i > 0}
                            card={
                              _.map(groupAppointmentByHour(lad.appointments), (time) => {
                                return _.map(time.data, (ap: AppointmentCardItemDayInterface, j: number) => {
                                  const count = _.filter(time.data, (list: AppointmentCardItemDayInterface, iList: number) => j + 1 > iList && list.doctorId === ap.doctorId && list.start === ap.start).length
                                  const allRow = _.filter(time.data, (list: AppointmentCardItemDayInterface) => list.doctorId === ap.doctorId).length
                                  const handlePatientCode = () => {
                                    if (branch?.patientCodeAppointment === '1') {
                                      return ap.cnNumber
                                    }
                                    if (branch?.patientCodeAppointment === '0') {
                                      return ap.branchCnNumber
                                    }
                                    if (branch?.patientCodeAppointment === '2') {
                                      return ap.snCode
                                    }
                                  }

                                  const isRangeEndAfterTimeOut = (rangeText: string, timeOutText: string): boolean => {
                                    const [startRaw, endRaw] = rangeText.split(' - ').map(s => s.trim())
                                    const start = moment(startRaw.replace(/\./g, ':'), 'HH:mm')
                                    const end = moment(endRaw.replace(/\./g, ':'), 'HH:mm')
                                    if (!end.isAfter(start)) {
                                      end.add(1, 'day')
                                    }
                                    const timeOut = moment(timeOutText, 'HH:mm')
                                    if (timeOut.isBefore(start)) {
                                      timeOut.add(1, 'day')
                                    }
                                    return end.isAfter(timeOut)
                                  }
                                  return (
                                    <CardAppointment
                                      key={j}
                                      appointmentId={ap.appointmentId}
                                      status={ap.statusAppointment}
                                      branchCnNumber={handlePatientCode() ? handlePatientCode() : ''}
                                      colorBackground={ap.color}
                                      serviceText={ap.serviceText}
                                      patientFullName={ap.patientFullname}
                                      rangeTimeText={ap.rangeTimeText}
                                      start={
                                        moment(ap.start, 'HH:mm')
                                          .add(count - 1)
                                          .format('HH:mm') || ap.rangeTimeText.split(' - ')[0].replace('.', ':')
                                      }
                                      end={
                                        isRangeEndAfterTimeOut(ap?.rangeTimeText, branch?.timeOut) ? moment(branch?.timeOut, 'HH:mm').add(20, 'minutes').format('HH:mm') : ap.end || ap.rangeTimeText.split(' - ')[1].replace('.', ':')
                                      }
                                      hasLab={ap.hasLab === 'HAS'}
                                      hasXray={ap.hasXray === 'HAS'}
                                      onViewDetail={props.type !== 'share' ? () => setViewDetails(() => ({ isShow: true, ...ap })) : _.noop}
                                      onPosition={props.type !== 'share' ? (translateY, translateX) => {
                                        const service = document.getElementById(`service-slider-container${idSuffix}`);
                                        const currentScrollTop = service?.scrollTop || 0;
                                        const currentScrollLeft = service?.scrollLeft || 0;

                                        // คำนวณตำแหน่ง X ของ card detail
                                        const cardAppointmentWidth = (widthCardAppointment / allRow);
                                        const cardDetailWidth = widthCardAppointment === 500 ? 420 : 380;
                                        const spaceBetween = 8;

                                        // หาความกว้างของ container
                                        const displayDays = document.querySelector(`.display-days`);
                                        const containerWidth = displayDays?.clientWidth || window.innerWidth;

                                        // แสดงทับเป็นค่าเริ่มต้น
                                        let cardDetailX = translateX;

                                        // ตรวจสอบว่าอยู่ขวาสุดหรือไม่ (ถ้าเกินขอบจอ)
                                        const cardRightEdge = translateX + cardAppointmentWidth;
                                        if (cardRightEdge + cardDetailWidth > containerWidth - 20) {
                                          // ถ้าอยู่ขวาสุด ให้แสดงทางซ้าย
                                          cardDetailX = translateX - cardDetailWidth - spaceBetween;
                                          // ถ้าติดขอบซ้ายเกินไป ให้ชิดซ้าย
                                          if (cardDetailX < 8) {
                                            cardDetailX = 8;
                                          }
                                        }

                                        // เก็บตำแหน่งจริงที่รวม scroll offset ทั้ง X และ Y
                                        initialPositionRef.current = {
                                          top: translateY + currentScrollTop,
                                          left: cardDetailX + currentScrollLeft
                                        };
                                        // แสดงที่ตำแหน่ง visible
                                        setPosition({ top: translateY, left: cardDetailX });
                                      } : _.noop}
                                      timeStart={props.timeRange[0]}
                                      width={(widthCardAppointment / allRow)}
                                      countThis={count}
                                      translateX={(widthCardAppointment / allRow) * j}
                                      specialInfo={ap?.specialInfo}
                                      type={props.type}
                                      phone={ap?.phone}
                                      allRow={allRow >= 4}

                                      viewDetails={viewDetails}
                                      branch={props.branch}
                                      position={position}
                                      onEdit={props.onEdit}
                                      onEditSpecialInfo={props.onEditSpecialInfo}
                                      onEditFeedback={props.onEditFeedback}
                                      timeRange={props.timeRange}
                                      setViewDetail={setViewDetails}
                                    />
                                  )
                                })
                              })
                            }
                            // popup={
                            //   _.map(lad.appointments, (ap: AppointmentCardItemDayInterface, j: number) => (
                            //     <CardAppointmentDetail
                            //       key={j}
                            //       timeStart={props.timeRange[0]}
                            //       timeEnd={props.timeRange[props.timeRange.length - 1]}
                            //       appointmentId={ap.appointmentId}
                            //       showPopup={_.find(viewDetails, (v) => v === ap.appointmentId) ? true : false}
                            //       onClose={handleCloseDetail}
                            //       onEdit={props?.onEdit ? props?.onEdit : undefined}
                            //       onEditSpecialInfo={props.onEditSpecialInfo ? props.onEditSpecialInfo : undefined}
                            //       status={ap.statusAppointment}
                            //       branch={props.branch}
                            //       isNotShowPhoneNumber={user.hasShowPhoneNumber === 'UNPERMISS'}
                            //       popAutoScroll
                            //     />
                            //   ))
                            // }
                            break={
                              <>
                                {(lad.breaks || []).map((brk: any, brkIdx: number) => (
                                  <CardBreak
                                    key={`break-${brkIdx}`}
                                    start={moment(brk.breakTimeStart || brk.timeStart, 'HH:mm').format('HH:mm')}
                                    end={moment(brk.breakTimeEnd || brk.timeEnd, 'HH:mm').format('HH:mm')}
                                    message={brk.message}
                                    color={brk.color}
                                    timeStart={props.timeRange[0]}
                                    width={widthCardAppointment}
                                    translateX={widthCardAppointment}
                                  />
                                ))}
                                {(!lad.breaks || lad.breaks.length === 0) && lad.breakTimeStart && lad.breakTimeStart !== '00:00' && (
                                  <CardBreak
                                    start={moment(lad.breakTimeStart, 'HH:mm').format('HH:mm')}
                                    end={lad.breakTimeEnd}
                                    timeStart={props.timeRange[0]}
                                    width={widthCardAppointment}
                                    translateX={widthCardAppointment}
                                  />
                                )}
                              </>
                            }
                          />
                        </div>
                      )
                    })}
                  </div>


                </div>
              </div>
            </ScrollSyncNode>
          </Box>
        </ScrollSync>

      </DivDisplayDay>
    ) || (
      <Typography className='text-center my-4' sx={{ fontWeight: 500, color: colors.textLightGray }}>{t('CLINIC_CLOSE')}</Typography>
    )
  )
}
